import { GameIntroBaseScene } from "src/games/shared/scenes/GameIntroBase";
import { Games } from "src/constants/Games";
import { HowToPlayScene } from "./IntroductionScene";

export class GameIntroScene extends GameIntroBaseScene {
    constructor() {
        super();
        this.gameRef = Games.CareerFair;
        this.howToPlayScene = HowToPlayScene;
        this.introTextKeys = [
            "CareerFair.Phaser.IntroductionScene.1",
            "CareerFair.Phaser.IntroductionScene.2",
            "CareerFair.Phaser.IntroductionScene.3",
        ];
    }
}



// WEBPACK FOOTER //
// ./src/games/CareerFairGame/scenes/GameIntro.ts